import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';

/* Logo band + a single customer quote. Wordmarks are set in neutral ink
 rather than brand colours so the band reads as one quiet texture and the
 quote beside it keeps the attention. */

const LOGOS = ['Shopify', 'Notion', 'Ramp', 'Linear', 'Vercel', 'Stripe', 'Figma', 'Brex', 'Retool', 'Webflow', 'Mercury', 'Loom', 'Attio', 'Cursor'];
export function TrustedBy() {
  return <section className="px-6 py-20 md:px-10 md:py-28" data-id="element-3143" data-mp="1hb492w0hd9j0">
      <div className="mx-auto max-w-[1100px]" data-id="element-3144" data-mp="1cdm7xrspfylk">
        <ul className="grid grid-cols-2 gap-x-8 gap-y-9 sm:grid-cols-4 lg:grid-cols-7" data-id="element-3145" data-mp="1r3aaewcmh3av">
          {LOGOS.map(logo => <li key={logo} className="flex items-center justify-center" data-id="element-3146" data-mp="1m4gvr0lln694">
              <span className="font-title text-lg font-bold tracking-tight text-[#2B211A]/35 md:text-xl" data-id="element-3147" data-mp="1m6a2efw7pqh4">
                {logo}
              </span>
            </li>)}
        </ul>

        <div className="mt-20 grid gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-3148" data-mp="1w3y11gwxvi4k">
          <div data-id="element-3149" data-mp="2qsed0leydb22">
            <h2 className="font-title text-2xl font-medium leading-snug tracking-tight md:text-4xl" data-id="element-3150" data-mp="2qsxs7ud7xlce">
              Trusted by teams at 1,200 companies.
              <span className="block text-neutral-400" data-id="element-3151" data-mp="2zsawm8mhjjq9">
                See how they roll Giga out across the org.
              </span>
            </h2>
            <Link to="/unlisted/case-studies" className="group mt-8 inline-flex items-center gap-3 font-semibold text-[#2B211A]" data-id="element-3152" data-mp="34syvfggyh4v1">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#2B211A]/8 transition-colors group-hover:bg-[#2B211A]/15" data-id="element-3153" data-mp="39onw5n4porsx">
                <ArrowRightIcon size={16} strokeWidth={2.5} data-id="element-3154" data-mp="3ijtwi6l7qho2" />
              </span>
              Customer stories
            </Link>
          </div>

          <figure data-id="element-3155" data-mp="3njq0i5twu93m">
            <blockquote className="text-lg leading-relaxed text-[#2B211A] md:text-xl" data-id="element-3156" data-mp="3sh8a7yfr4sco">
              “Giga became the place our teams actually ask questions. Nine
              hundred people use it every week, and it answers from our own
              systems — inside Slack, with the access controls our security
              team signed off on.”
            </blockquote>
            <figcaption className="mt-6 text-[15px] text-neutral-500" data-id="element-3157" data-mp="32qq7o9d00bez">
              Dana Whitfield, VP Operations
              <span className="mt-3 block font-title text-xl font-bold tracking-tight text-[#2B211A]/40" data-id="element-3158" data-mp="3cr0jpqnarcsk">
                Ramp
              </span>
            </figcaption>
          </figure>
        </div>
      </div>
    </section>;
}